import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

export enum SourceStatus {
  Craigslist = 'Craigslist',
  CurrentEmployee = 'Current Employee',
  Dice = 'Dice',
  Facebook = 'Facebook',
  FormerEmployee = 'Former Employee',
  Glassdoor = 'Glassdoor',
  HireEz = 'HireEz',
  Indeed = 'Indeed',
  LinkedIn = 'LinkedIn',
  Monster = 'Monster',
  Newsletter = 'Newsletter',
  Other = 'Other',
  Referral = 'Referral',
  Website = 'Website',
  ZipRecruiter = 'ZipRecruiter',
}

@Component({
  selector: 'mojo-candidate-source',
  templateUrl: './candidate-source.component.html',
  styleUrls: ['/candidate-source.component.scss'],
})
export class CandidateSourceComponent {
  @Input()
  form: UntypedFormGroup;

  items = Object.values(SourceStatus);

  sourceStatus = SourceStatus;

  getSourceNotePlaceholder() {
    if (this.form.controls.source.value === SourceStatus.Referral) {
      return 'Required: Enter the name of the referrer and notes';
    } else {
      return 'Required: Enter comments';
    }
  }
}
